export const companyInfo = {
  name: "Layne Red",
  description: "Premium clothings by Laynered brings out oversized printed tshirts with everlasting print and quality",
  address: "Alleppey, Kerala, India",
  phone: "+91 92072 07469",
  email: "official.laynered@gmail.com",
};

export const faqs = [
  {
    question: "Can I cancel an Order?",
    answer: "You can cancel your order on the same day it is placed or before it is dispatched. Once the order is dispatched or the placement date has passed, cancellation is not available."  },
  {
    question: "What is your exchange policy?",
    answer: "Exchanges are valid only within 3 days of delivery and are limited to size changes. No exchanges will be accepted after this period.",
  },
  {
    question: "What is your return policy for damaged products?",
    answer: "Returns are accepted only for damaged products. We strictly monitor all items before shipping to prevent fraudulent returns. Any fraudulent attempts will be handled legally. Contact our support team for assistance.",
  },
  {
    question: "What makes Layne Red's products stand out?",
    answer: "Our products are picked from premium clothing manufactures offering high quality prints that helps our products maintain the freshness everlong",
  },
];